<script>
  import { ChevronsLeftIcon, ChevronsRightIcon } from "svelte-feather-icons"
  import ADSBOptions from "./ADSBOptions.svelte";
  import Overlays from "./Overlays.svelte";

	import { fly } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';
  import SRSMonitorOptions from "./SRSMonitorOptions.svelte";


  let sidebarOpen = false

  function toggleSidebar() {
    sidebarOpen = !sidebarOpen
  }
</script>

<div on:click={toggleSidebar} class:open={sidebarOpen} class='tabHandle'>
  {#if sidebarOpen}
    <ChevronsRightIcon/>
  {:else}
    <ChevronsLeftIcon/>
  {/if}
</div>
{#if sidebarOpen}
  <div class='sidebarMain' class:open={sidebarOpen}>
    <Overlays/>
    <ADSBOptions />
    <SRSMonitorOptions/>
  </div>
{/if}

<style>
  .tabHandle {
    position:relative;
    display:flex;
    align-items: center;
    justify-self:right;
    justify-content: center;
    right:0;
    top: 60px;
    background-color:white;
    z-index:6;
    color: grey;
    border:1px solid black;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    grid-column: 1;
    grid-row: 1;
    height: 28px;
  }

  .tabHandle:hover {
    padding:2px;
    color:black;
  }

  .tabHandle.open {
    padding:2px;
    border-right:0px;
    background-color:grey;
    color: white;
    border:0;
  }

  .sidebarMain {
    grid-column: 2;
    width: 0px;
    margin:8px;
    transition: width 1s;
  }

  .sidebarMain.open {
    width:250px;
  }

  @media only screen and (max-width: 600px) { 
    .sidebarMain {
      margin-top: 80px;
      height: 100vh;
      grid-column: 1;
    }
    .sidebarMain.open {
      width: 93%;
    }
  }
</style>